import messageResource from '../messageResource'

export const taskNameLower = (n) => {
    return n !== 1 ? messageResource.getMessage('common.tasks') : messageResource.getMessage('common.task')
}

export const customerNameLower = (n) => {
    return n !== 1 ? messageResource.getMessage('common.customers') : messageResource.getMessage('common.customer')
}

export const projectNameLower = (n) => {
    return n !== 1 ? messageResource.getMessage('common.projects') : messageResource.getMessage('common.project')
}

export const departmentNameLower = n => {
    return n !== 1 ? messageResource.getMessage('common.user_groups') : messageResource.getMessage('common.user_group')
}

export const tzgNameLower = n => {
    return n !== 1 ? messageResource.getMessage('common.time_zone_groups') : messageResource.getMessage('common.time_zone_group')
}

export const userNameLower = n => {
    return n !== 1 ? messageResource.getMessage('common.users') : messageResource.getMessage('common.user')
}

export const managerLower = n => {
    return n !== 1 ? messageResource.getMessage('common.managers') : messageResource.getMessage('common.manager')
}

export const managerCapitalized = n => {
    return n !== 1 ? messageResource.getMessage('common.Managers') : messageResource.getMessage('common.Manager')
}

export const userNameCapitalizedSingular = () => messageResource.getMessage('common.User')

export const userNameCapitalizedPlural = () => messageResource.getMessage('common.Users')

export const userNameCapitalized = n => {
    return n !== 1 ? userNameCapitalizedPlural() : userNameCapitalizedSingular()
}

export const departmentNameCapitalizedSingular = () => messageResource.getMessage('common.User_Group')
export const departmentNameCapitalizedPlural = () => messageResource.getMessage('common.User_Groups')
export const departmentNameCapitalized = n => {
    return n !== 1 ? departmentNameCapitalizedPlural() : departmentNameCapitalizedSingular()
}

export const tzgNameCapitalizedSingular = () => messageResource.getMessage('common.Time_Zone_Group')
export const tzgNameCapitalizedPlural = () => messageResource.getMessage('common.Time_Zone_Groups')
export const tzgNameCapitalized = n => {
    return n !== 1 ? tzgNameCapitalizedPlural() : tzgNameCapitalizedSingular()
}

export const daysNameLower = (n) => n === 1 ? messageResource.getMessage('common.day') : messageResource.getMessage('common.days')



// WEBPACK FOOTER //
// ./web/js/util/pluralizeUtils.js